var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-tree',{ref:"roleResourceTree",attrs:{"accordion":true,"check-strictly":true,"data":_vm.treeData,"node-key":"id","default-checked-keys":_vm.checkeds,"show-checkbox":"","props":_vm.defaultProps},on:{"check":_vm.nodeCheck}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4968cc7b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/cdpBase/baseComponents/authTree/src/main.vue
// module id = null
// module chunks = 